import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            <i className="ri-flashlight-line text-sm"></i>
            实时快讯
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            最新动态
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            随时随地掌握娱乐圈最新爆料，动态实时更新不错过任何猛料
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-0.5 bg-background-200 hidden sm:block"></div>

          <div className="space-y-0">
            {updateItems.map((item, idx) => (
              <div key={item.id} className="relative flex gap-4 pb-5 last:pb-0">
                <div className="hidden sm:flex flex-col items-center flex-shrink-0">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-full border-2 z-10 ${
                    idx === 0 ? 'bg-primary-500 border-primary-500 text-white' :
                    idx < 3 ? 'bg-accent-100 border-accent-300 text-accent-700' :
                    'bg-background-50 border-background-300 text-foreground-500'
                  }`}>
                    <i className={`text-sm ${
                      idx === 0 ? 'ri-bell-line' :
                      idx < 3 ? 'ri-fire-line' :
                      'ri-circle-fill'
                    }`}></i>
                  </div>
                </div>

                <div className="flex-1 bg-background-100 rounded-2xl p-4 md:p-5 border border-background-200 cursor-pointer transition-all duration-200 hover:shadow-md hover:-translate-y-0.5">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-foreground-400 text-xs">{item.date}</span>
                    <span className="text-foreground-300 text-xs">{item.time}</span>
                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${
                      item.tag === '爆' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '热' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '最新' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-background-200 text-foreground-600'
                    }`}>{item.tag}</span>
                  </div>
                  <p className="text-foreground-950 text-sm leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}